export default __webpack_public_path__ + "static/media/right-arrow.26a62e3f.svg";